import { formDefinition } from '@social-solutions/ssg-forms-processing';

export const newPasswordElement = {
  id: 'new-password',
  label: 'NEW PASSWORD',
  ariaLabel: "New password",
  type: formDefinition.elementTypes.specialText,
  textType: formDefinition.specialTextTypes.ANY,
  isPassword: true,
  isRequired: true,
};

export const confirmPasswordElement = {
  id: 'confirm-password',
  label: 'CONFIRM NEW PASSWORD',
  ariaLabel: "Confirm new password",
  type: formDefinition.elementTypes.specialText,
  textType: formDefinition.specialTextTypes.ANY,
  isPassword: true,
  isRequired: true,
};

const resetPasswordForm = {
  id: 'reset-password',
  name: null,
  elements: [newPasswordElement, confirmPasswordElement]
}

export default resetPasswordForm;



// WEBPACK FOOTER //
// src/acct/password/reset-password-form-definition.js